module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1300.1a4d40e0.svg";